import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowRight, Info } from "lucide-react";
import { locationMateriel } from "../mock/extraData";
import Reveal from "../components/Reveal";

const LocationMateriel = () => {
  const navigate = useNavigate();
  useEffect(() => window.scrollTo(0, 0), []);

  return (
    <div className="pt-16 sm:pt-20">
      {/* HERO */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img src={locationMateriel.hero.image} alt="Location de matériel" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#131f38]/95 to-[#1B2A4A]/70" />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-28">
          <div className="max-w-2xl animate-fadeUp">
            <span className="inline-block bg-[#C9A227] text-white text-xs font-semibold px-4 py-1.5 rounded-full mb-5 uppercase tracking-wider">Location</span>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white leading-tight">{locationMateriel.hero.title}</h1>
            <p className="mt-5 text-lg text-gray-200 max-w-xl">{locationMateriel.hero.subtitle}</p>
            <button onClick={() => navigate("/contact")} className="mt-8 inline-flex items-center gap-2 bg-[#C9A227] hover:bg-[#b8931f] text-white font-semibold px-7 py-3.5 rounded-lg transition-colors shadow-lg">
              Réserver du matériel <ArrowRight size={18} />
            </button>
          </div>
        </div>
      </section>

      {/* INTRO */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          {locationMateriel.intro.map((p, i) => (
            <p key={i} className="text-gray-600 leading-relaxed mb-4 text-lg">{p}</p>
          ))}
        </div>
      </section>

      {/* ITEMS */}
      <section className="py-16 bg-[#f7f9fc]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal className="text-center max-w-2xl mx-auto mb-14">
            <span className="text-[#C9A227] font-semibold text-sm uppercase tracking-wider">Notre matériel</span>
            <h2 className="text-3xl sm:text-4xl font-bold text-[#1B2A4A] mt-2">Tout l'équipement pour déménager</h2>
          </Reveal>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {locationMateriel.items.map((item, i) => {
              const Icon = Icons[item.icon] || Icons.Package;
              return (
                <Reveal key={i} delay={(i % 3) * 100} className="group bg-white rounded-2xl p-7 border border-gray-100 shadow-sm hover:shadow-xl hover:-translate-y-1 hover:border-[#C9A227]/40 transition-all duration-300">
                  <div className="flex items-center justify-between">
                    <div className="w-14 h-14 rounded-xl bg-[#1B2A4A]/5 group-hover:bg-[#1B2A4A] flex items-center justify-center transition-colors duration-300">
                      <Icon size={26} className="text-[#1B2A4A] group-hover:text-white transition-colors duration-300" />
                    </div>
                    <span className="text-sm font-bold text-[#C9A227] bg-[#C9A227]/10 px-3 py-1 rounded-full">{item.price}</span>
                  </div>
                  <h3 className="mt-5 text-lg font-bold text-[#1B2A4A]">{item.name}</h3>
                  <p className="mt-2 text-gray-600 text-sm leading-relaxed">{item.desc}</p>
                </Reveal>
              );
            })}
          </div>
          <Reveal className="mt-10 flex items-start gap-3 bg-white rounded-xl p-5 border border-gray-100 shadow-sm max-w-3xl mx-auto">
            <Info size={20} className="text-[#C9A227] mt-0.5 shrink-0" />
            <p className="text-sm text-gray-600">Tarifs indicatifs dégressifs selon la durée. Caution demandée à la réservation. Livraison possible sur demande.</p>
          </Reveal>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-[#1B2A4A] mb-4">Réservez votre matériel</h2>
          <p className="text-gray-600 mb-8">Dites-nous ce dont vous avez besoin, nous préparons votre commande.</p>
          <button onClick={() => navigate("/contact")} className="inline-flex items-center gap-2 bg-[#1B2A4A] hover:bg-[#26406b] text-white font-semibold px-7 py-3.5 rounded-lg transition-colors shadow-sm">
            Faire une demande <ArrowRight size={18} />
          </button>
        </div>
      </section>
    </div>
  );
};

export default LocationMateriel;
